import { Auth } from "aws-amplify";

export const getUserRole = async () => {
  const user = await Auth.currentAuthenticatedUser();
  return user.attributes["custom:nostra-user-role"];
};
